var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWesoLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 163,
    height: 57,
    viewBox: "0 0 163 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.427 4H12.7001C5.68605 4 0 9.67441 0 16.6741V39.453C0 46.4527 5.68605 52.1272 12.7001 52.1272H35.427C42.4411 52.1272 48.1272 46.4527 48.1272 39.453V16.6741C48.1272 9.67441 42.4411 4 35.427 4Z",
    fill: "url(#paint0_linear_2183_77)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1319 20.1775C40.328 18.5923 38.6363 20.6361 37.8307 23.5423L33.2774 37.4806C31.985 41.085 26.7662 41.47 25.1603 37.6693L23.0185 30.5567L20.339 38.4411C19.4021 40.8453 14.7192 41.7115 12.8453 37.5768L7.61602 21.0286L7.41987 20.4096C7.37537 20.1902 7.35305 19.9662 7.35332 19.7416C7.3458 19.0502 7.5612 18.3775 7.96275 17.8382C8.36431 17.2989 8.92712 16.9266 9.5551 16.7847C10.1831 16.6428 10.8373 16.7402 11.4061 17.0602C11.9748 17.3803 12.4229 17.9031 12.6737 18.5395L12.7087 18.632C12.7084 18.6383 12.7084 18.6446 12.7087 18.6508L17.1202 30.368L19.8417 21.14C21.9432 15.5654 26.7224 15.1785 28.8169 20.5097L30.7241 26.5711L31.9289 22.7742C32.7748 20.1171 33.9306 18.2451 35.407 17.1978C38.5523 15.9013 40.4191 17.4129 41.1319 20.1775Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0297 30.583L27.1977 17.9053C28.1745 18.9374 28.8611 20.2456 29.1784 21.6796L30.7371 26.5861L34.2764 34.3233L33.3149 37.3899C31.9017 40.9754 26.8755 41.7302 25.1417 37.6031L23.0297 30.583Z",
    fill: "url(#paint1_linear_2183_77)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M93.8508 28.39V28.0402C93.8508 20.7029 98.9163 16.0723 105.325 16.0723C111.121 16.0723 116.1 19.655 116.1 27.8653C116.1 28.4096 115.899 28.9316 115.542 29.3164C115.185 29.7013 114.701 29.9175 114.195 29.9175H101.182C101.383 32.9332 103.001 34.6793 105.599 34.6793C107.227 34.6793 108.216 34.1335 108.77 33.3026C109.049 32.8895 109.415 32.5534 109.838 32.322C110.261 32.0906 110.728 31.9704 111.202 31.9712C114.116 31.9712 115.351 35.9836 113.007 37.8519C111.188 39.2904 108.629 40.0579 105.352 40.0579C98.7106 40.0519 93.8508 35.8585 93.8508 28.39ZM109.05 25.507C108.928 22.7551 107.672 21.2262 105.321 21.2262C103.132 21.2262 101.632 22.7551 101.263 25.507H109.05Z",
    fill: "#111111"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M122.334 32.289H122.779C123.258 32.2971 123.727 32.4355 124.143 32.6912C124.558 32.9469 124.908 33.3116 125.158 33.7516C125.593 34.4784 126.354 34.866 127.697 34.866C129.482 34.866 130.292 34.1226 130.292 32.9872C130.292 31.8955 129.279 31.3707 126.36 30.9349C120.685 30.1478 118.294 28.358 118.294 23.5962C118.294 18.5297 122.47 16.084 127.374 16.084C129.893 16.084 132.055 16.5363 133.671 17.6099C136.177 19.2897 135.054 23.4665 132.102 23.4665C131.168 23.4665 130.251 23.0247 129.724 22.1984C129.288 21.5244 128.576 21.1941 127.469 21.1941C125.888 21.1941 125.078 21.9375 125.078 22.9855C125.078 24.0772 126.057 24.5145 128.645 24.8643C134.522 25.6499 137.358 27.31 137.358 32.2015C137.358 37.6178 133.629 40.0636 127.752 40.0636C124.653 40.0636 122.214 39.3488 120.554 37.9691C118.311 36.1235 119.527 32.289 122.334 32.289Z",
    fill: "#111111"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M139.28 28.3814V28.0315C139.28 20.6927 144.347 16.0636 150.913 16.0636C157.439 16.0636 162.464 20.5631 162.464 27.8129V28.1627C162.464 35.5874 157.399 40.0417 150.872 40.0417C144.346 40.0417 139.28 35.7624 139.28 28.3814ZM155.093 28.2502V27.9003C155.093 24.0568 153.674 21.9171 150.917 21.9171C148.201 21.9171 146.702 23.9693 146.702 27.8129V28.1627C146.702 32.0937 148.121 34.2334 150.917 34.2334C153.629 34.2334 155.088 32.05 155.088 28.2502H155.093Z",
    fill: "#111111"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M93.9727 19.6077C93.168 18.0169 91.4735 20.06 90.6661 22.9792L86.1071 36.9451C84.8113 40.564 79.5821 40.9425 77.9729 37.1381L75.8263 30.0104L73.141 37.9086C72.2021 40.3212 67.5102 41.1837 65.6323 37.0416L60.3918 20.4551L60.1959 19.8338C60.1503 19.6141 60.1273 19.3896 60.1274 19.1643C60.1194 18.4714 60.335 17.797 60.7373 17.2562C61.1395 16.7155 61.7035 16.3421 62.3329 16.1997C62.9623 16.0573 63.618 16.1547 64.1882 16.4754C64.7583 16.7961 65.2074 17.3202 65.4588 17.9581L65.4951 18.0515C65.4957 18.0576 65.4957 18.0636 65.4951 18.0696L69.9226 29.8174L72.6499 20.5697C74.7488 14.9906 79.5443 14.5955 81.6433 19.9394L83.5547 26.0116L84.7609 22.2087C85.6103 19.5473 86.7676 17.6716 88.248 16.6206C91.3811 15.3208 93.259 16.8362 93.9727 19.6077Z",
    fill: "#111111"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2183_77",
    x1: 0,
    y1: 28.0636,
    x2: 48.1272,
    y2: 28.0636,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2C7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FF7334"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7334"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2183_77",
    x1: 28.653,
    y1: 40.3866,
    x2: 28.653,
    y2: 17.8959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#FDFDFD",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F6F6F6",
    stopOpacity: 0.97
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#EBEBEB",
    stopOpacity: 0.92
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#DADADA",
    stopOpacity: 0.86
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#C4C4C4",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#A8A8A8",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#888888",
    stopOpacity: 0.56
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#626262",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#373737",
    stopOpacity: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#090909",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.05
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWesoLogo);
export default __webpack_public_path__ + "static/media/weso-logo.c2dbcebb614241045b696079434cff8c.svg";
export { ForwardRef as ReactComponent };